import Prebooking from "../../booking/types/Prebooking";
import EventCity from "../../eventCities/types/EventCity";

interface BannerDates {
    startDate: string;
    endDate: string;
}

/**
 * Gets formatted start and end dates for the banner
 * If eventCity has accommodationDates with the same salesChannel as preBooking, it uses those dates
 * Otherwise, it uses the startDate and endDate from eventCity
 * Returns an object with formatted dates in DD/MM/YYYY format
 */
export function getAccommodationDates(
    preBooking?: Prebooking,
    eventCity?: EventCity,
): BannerDates {
    if (!preBooking || !eventCity) return { startDate: '', endDate: '' };

    const accommodationDate = eventCity.accommodationDatesSalesChannels?.find(
      (acc) => acc.salesChannel === preBooking.salesChannel
    );

    const startDateStr = accommodationDate?.accommodationStartDate || eventCity.startDate;
    const endDateStr = accommodationDate?.accommodationEndDate || eventCity.endDate;

    return {
        startDate: startDateStr,
        endDate: endDateStr,
    };
}

